const clients = [
  { name: "NORTHWIND", suffix: "STUDIOS" },
  { name: "halden", suffix: "& co." },
  { name: "ASTRA", suffix: "WELLNESS" },
  { name: "Mercer", suffix: "Partners" },
  { name: "ORBIT", suffix: "LABS" },
  { name: "lumen", suffix: "/ retail" },
  { name: "VANTAGE", suffix: "GROUP" },
  { name: "Kindred", suffix: "Health" },
];

export default function ClientLogos() {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative py-16 md:py-24 bg-[#050505] border-y border-white/[0.04]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00F0FF]">
              / Trusted by
            </div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-extrabold leading-[0.95] tracking-[-0.03em]">
              Brands building
              <br />
              <span className="text-slate-500">with us.</span>
            </h2>
          </div>
          <p className="md:max-w-sm text-slate-400 text-base leading-relaxed">
            From bootstrapped founders to scaling SMBs — selected partners we've shipped with.
          </p>
        </div>

        <div
          data-testid="clients-grid"
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 divide-x divide-y divide-white/[0.06] border border-white/[0.06] rounded-3xl overflow-hidden"
        >
          {clients.map((c, i) => (
            <div
              key={c.name}
              data-testid={`client-logo-${i}`}
              className="group relative aspect-[5/2] flex items-center justify-center px-6 py-6 transition-colors hover:bg-white/[0.02]"
            >
              <div className="flex flex-col items-center gap-1 text-slate-300 group-hover:text-white transition-colors">
                <span className="font-display text-xl md:text-2xl font-extrabold tracking-tight">
                  {c.name}
                </span>
                <span className="text-[10px] uppercase tracking-[0.28em] text-slate-500 group-hover:text-[#00F0FF] transition-colors">
                  {c.suffix}
                </span>
              </div>
              <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="absolute -inset-px"
                  style={{
                    background:
                      "radial-gradient(220px circle at center, rgba(0,122,255,0.12), transparent 60%)",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="reveal mt-8 flex flex-wrap items-center gap-6 text-sm text-slate-500">
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" />
            40+ engagements delivered
          </div>
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" />
            Avg. 38% revenue lift in 90 days
          </div>
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" />
            UK-based, working globally
          </div>
        </div>
      </div>
    </section>
  );
}
